module.exports = __webpack_public_path__ + "static/media/icon-plus-circle.0c982892.svg";